import { useState, useEffect } from 'react'

import { sortSpan, handleSort, performSort } from './auctionsadminutil'
import { canEditAuction } from './permissionsutil'

import css from './sass/adminitem.module.scss'
import adminCss from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import ItemDisplayRow from './ItemDisplayRow'

import CreateItem from './CreateItem'
import ItemEdit from './ItemEdit'
import { getAuctionStatus } from '../util/dateString'
import SortNotice from './SortNotice'
import CreateFixedItem from './FixedItem/CreateFixedItem'
import FixedItemEdit from './FixedItem/FixedItemEdit'
import FixedItemDisplay from './FixedItem/FixedItemDisplay'
import CategoriesModal from './CategoriesModal'
import { shouldShowArrangeDisplayOrder } from './itemorderutils'

export default function ItemDisplay( {selectedAuction, refreshAdminAuctionQuery, hasEnded, 
  setSortedItems, sortedItems, tableFormatter, isUserSR, fixedTableFormatter, setSortedFixedItems, sortedFixedItems,
  onArrangeDisplayOrder} ) {
    //need to install

  const [showItemModal, setShowItemModal] = useState(false)
  const [showFixedItemModal, setShowFixedItemModal] = useState(false)
  const [editItem, setEditItem] = useState()
  const [showEditModal, setShowEditModal] = useState(false)
  const [showFixedEditModal, setShowFixedEditModal] = useState(false)
  
  const [displayItems, setDisplayItems] = useState([])
  const [displayFixedItems, setDisplayFixedItems] = useState([])
  const [sortOptions, setSortOptions] = useState({ key: '', dir: 'asc' })
  const [hideCloseModalButton, setHideCloseModalButton] = useState()

  const [showCategoriesModal, setShowCategoriesModal] = useState(false)

  const isSrApproved = selectedAuction?.ReviewStatus === "Approved"
  const liveStatus = getAuctionStatus(selectedAuction?.StartTime, selectedAuction?.EndTime)
  const showArrangeDisplayOrder = shouldShowArrangeDisplayOrder(selectedAuction)

  const showEditItemModal = () => {
    let newValue = !showEditModal
    setShowEditModal(newValue)
  }

  const updateEditItemId = (id) => {
    const updatedItem = selectedAuction.Items.find(ele => ele.ItemId === id)
    setEditItem(updatedItem)
    showEditItemModal()
  }

  const showCreateItemModal = () => {
    let newValue = !showItemModal
    setShowItemModal(newValue)
  }

  const showCreateFixedItemModal = () => {
    let newValue = !showFixedItemModal
    setShowFixedItemModal(newValue)
  }

  const showEditFixedItemModal = () => {
    let newValue = !showFixedEditModal
    setShowFixedEditModal(newValue)
    }
  const toggleCategoriesModal = () => {
    let newValue = !showCategoriesModal
    setShowCategoriesModal(newValue)
  }

  useEffect(() => {

    console.log('selected', selectedAuction)

    const fullName = ( bidderInfo ) => {
      if (!bidderInfo.FirstName || !bidderInfo.LastName) return 'N/A'
      return `${bidderInfo.FirstName} ${bidderInfo.LastName}`
    }

    if (selectedAuction.Items) {
      const output = selectedAuction.Items.map((item) => {
        return {
          ...item,
          BidderFullName: fullName(item.CurrentHighBidderInfo),
          ItemCode: parseInt(item.ItemCode)
        }
      })
      setDisplayItems(output)
    }

    if (selectedAuction.FixedItems) {
      const output = selectedAuction.FixedItems.map((fixedItem) => {
        return {
          ...fixedItem,
          // BidderFullName: fullName(fixedItem.CurrentHighBidderInfo),
          ItemCode: parseInt(fixedItem.ItemCode)
        }
      })
      setDisplayFixedItems(output)
    }

  }, [selectedAuction])

  useEffect(() => {

    setSortedItems(performSort(displayItems, sortOptions))

  }, [displayItems, sortOptions])

  // const sortedItems = performSort(displayItems, sortOptions)

  // maybe provide a link for if no auction is loaded to reroute to load auctions - 404 something
  if (!selectedAuction) return (<></>)
  
  return (
    <>
      <div>

        {!(hasEnded === true && selectedAuction.Status !== 'PREVIEW') && canEditAuction(selectedAuction) && !isUserSR &&
          <div className={css['admin-item-button-header']}>
            <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} disabled={isSrApproved} onClick={()=> showCreateItemModal()} >
              Add Auction Item
            </button>
            {displayFixedItems.length === 0 && <button 
                className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} disabled={isSrApproved} onClick={()=> showCreateFixedItemModal()} >
              Add Fixed-Price Item
            </button>}
            {showArrangeDisplayOrder &&
              <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={onArrangeDisplayOrder}>
                Arrange Display Order
              </button>
            }
            <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} onClick={()=> toggleCategoriesModal()} >
              Edit Categories
            </button>
          </div>
        }
      
          

        {selectedAuction.Items.length !== 0 && 
        <>
          <SortNotice />
          <table className={themeCss['data-table']}>
            <thead>
              <tr>
                {!isUserSR && <th>Actions</th>}
                <th></th>
                {tableFormatter.map((ele) => {
                  return (
                    <th onClick={() => handleSort(ele[0], sortOptions, setSortOptions)} key={ele[1]}>
                    {ele[1]} {sortSpan(ele[0], sortOptions)}</th>
                  )})}
              </tr>
            </thead>
            <tbody >
              {sortedItems && sortedItems.map((item) => {
                return (
                  <ItemDisplayRow key={item.ItemId} auction={selectedAuction} liveStatus={liveStatus} item={item}
                  refreshAdminAuctionQuery={refreshAdminAuctionQuery}
                  updateEditItemId={updateEditItemId} hasEnded={hasEnded} isUserSR={isUserSR} />
                )
              })}
            </tbody>
          </table>
        </>}

        {displayFixedItems.length !== 0 && <FixedItemDisplay fixedItems={displayFixedItems} isUserSR={isUserSR}
        selectedAuction={selectedAuction} refreshAdminAuctionQuery={refreshAdminAuctionQuery} hasEnded={hasEnded}
        sortedFixedItems={sortedFixedItems} setSortedFixedItems={setSortedFixedItems} fixedTableFormatter={fixedTableFormatter}
        onArrangeDisplayOrder={onArrangeDisplayOrder} showArrangeDisplayOrder={showArrangeDisplayOrder}
        />}

        {(selectedAuction.Items?.length ?? 0) === 0 && (selectedAuction.FixedItems?.length ?? 0) === 0 && <p>No Items, add some!</p>}
        
      </div>
      {showItemModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>showCreateItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>showCreateItemModal()} >Close Modal</button>}
            <CreateItem refreshAdminAuctionQuery={refreshAdminAuctionQuery} auction={selectedAuction} 
              setShowModal={setShowItemModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
        </>
      }
      {showEditModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>showEditItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            <ItemEdit item={editItem} auction={selectedAuction} refreshAdminAuctionQuery={refreshAdminAuctionQuery} showEditItemModal={showEditItemModal}
              setShowModal={setShowEditModal} setHideCloseModalButton={setHideCloseModalButton} hideCloseModalButton={hideCloseModalButton} />
          </div>
        </>
      }
      {showFixedItemModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>showCreateFixedItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>showCreateFixedItemModal()} >Close Modal</button>}
            <CreateFixedItem refreshAdminAuctionQuery={refreshAdminAuctionQuery} auction={selectedAuction} 
              setShowFixedItemModal={setShowFixedItemModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
        </>
      }
      {showFixedEditModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>showEditItemModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>showEditFixedItemModal()} >Close Modal</button>}
            <FixedItemEdit item={editItem} auction={selectedAuction} refreshAdminAuctionQuery={refreshAdminAuctionQuery} 
              setShowModal={setShowFixedEditModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
        </>
      }
      {showCategoriesModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>toggleCategoriesModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>toggleCategoriesModal()} >Close Modal</button>}
            <CategoriesModal refreshAdminAuctionQuery={refreshAdminAuctionQuery} auction={selectedAuction} 
              setShowModal={setShowCategoriesModal} setHideCloseModalButton={setHideCloseModalButton}/>
          </div>
        </>
      }
    </>
    )
  }
